module.exports = __webpack_public_path__ + "img/userRes_h.e8a94cb3.png";